export function exportToXLSX(transactions, items) {
  const ExcelJS = require("exceljs");
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Storage Transactions");

  // Header
  const headers = [
    "KODE BARANG",
    "DESCRIPTION ITEM",
    "TGL",
    "MASUK",
    "KELUAR",
    "SISA",
    "SATUAN",
    "SUPLIER",
    "HARGA",
    "KETERANGAN PENGGUNAAN",
  ];

  sheet.addRow(headers);
  sheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "D9E1F2" }, // light blue
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  transactions.forEach((tx, index) => {
    const item = items.find((i) => i.id === tx.item_id);
    const itemCode = item?.code || "-";
    const itemName = item?.description || "-";
    const itemUnit = item?.measurement_unit || "-";
    const formattedDate = new Date(tx.updated_at).toLocaleDateString("id-ID");

    const row = sheet.addRow([
      itemCode,
      itemName,
      formattedDate,
      tx.transaction_type === "in" ? tx.quantity : "",
      tx.transaction_type === "out" ? tx.quantity : "",
      "", // sisa stok (kosong)
      itemUnit,
      tx.supplier_name || "",
      tx.price_per_unit,
      tx.description || "",
    ]);

    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = { vertical: "middle" };
    });

    if (index % 2 === 0) {
      row.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F9F9F9" },
        };
      });
    }
  });

  // Format kolom harga
  const hargaCol = sheet.getColumn(9);
  hargaCol.numFmt = '"Rp" #,##0';

  // Set lebar kolom
  sheet.columns = [
    { width: 15 },
    { width: 30 },
    { width: 12 },
    { width: 10 },
    { width: 10 },
    { width: 10 },
    { width: 10 },
    { width: 20 },
    { width: 15 },
    { width: 40 },
  ];

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `storage_transactions_${Date.now()}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
}
